'use strict'


$(function() {    
    $('.js-accordion-headline').on('click', function(e) {
        var $content = $(this).next('.js-accordion-content');
        var height = 0;
        
        if (!$content.hasClass('-is-active')) {
            $content.css('height', 'auto');
            height = $content.height();
            $content.css('height', 0);
            
            window.setTimeout(function() {
                $content.css('height', height);
                $content.addClass('-is-active');
                $(this).addClass('-is-active');
            }.bind(this), 100);
        }
        else {
            $content.css('height', 0);
            $content.removeClass('-is-active');
            $(this).removeClass('-is-active');
        }
    });
});